/* eslint-disable sort-keys */
import {getMediaSrc} from 'core/helpers/media';
import {PRODUCT_PROPERTY_CODE_ART, UNKOWN_NAME} from 'modules/products/constants';
import {TNextUrlSlug} from 'core/types';
import {FILTER_URL_SLUG} from 'plugins/modules/filter/constants';
import {IProperty} from 'modules/products/types';

export const makeSources = (src: string) => {
    return {
        ['lg']: `${getMediaSrc(src, {
            height: 172,
            isWebp: true,
        })} 1x, ${getMediaSrc(src, {
            height: 344,
            isWebp: true,
        })} 2x`,
        ['xl']: `${getMediaSrc(src, {
            height: 180,
            isWebp: true,
        })} 1x, ${getMediaSrc(src, {
            height: 400,
            isWebp: true,
        })} 2x`,
        ['xs']: `${getMediaSrc(src, {
            height: 172,
            isWebp: true,
        })} 1x, ${getMediaSrc(src, {
            height: 344,
            isWebp: true,
        })} 2x`,
    };
};

export const makeMapPopupWineShopPhotoSources = (src: string) => {
    return {
        ['xl']: `${getMediaSrc(src, {height: 148, width: 260})} 1x, ${getMediaSrc(src, {height: 296, width: 520})} 2x`,
        ['sm']: `${getMediaSrc(src, {height: 124, width: 217})} 1x, ${getMediaSrc(src, {height: 248, width: 434})} 2x`,
    };
};

export const getFullName = (name = '', lastName = '', city = '') => {
    const withCity = (value: string) => {
        if (Boolean(city)) {
            return `${value}, ${city}`;
        }
        return value;
    };

    if (!name && !lastName) {
        return withCity(UNKOWN_NAME);
    }
    return withCity([name, lastName].join(' '));
};

export const getCatalogSection = (slug: TNextUrlSlug) => {
    if (!slug) {
        return '';
    }

    if ('string' === typeof slug) {
        return slug;
    }

    const filterSlugIndex = slug.indexOf(FILTER_URL_SLUG.replaceAll('/', ''));

    if (-1 === filterSlugIndex) {
        return slug.join('/');
    }

    return slug.slice(0, filterSlugIndex).join('/');
};

export const getAdditionalDataCatalog = (catalogRusName = '', properties?: IProperty[]) => {
    if (!properties) {
        return catalogRusName;
    }

    let additionalDataCatalog = catalogRusName;
    const manufacturerProperty = properties?.find((item) => 'manufacturer' === item.code)?.value;
    if (manufacturerProperty && 'object' === typeof manufacturerProperty && 'value' in manufacturerProperty) {
        additionalDataCatalog =
            catalogRusName !== manufacturerProperty.value
                ? `${catalogRusName}, ${manufacturerProperty.value}`
                : catalogRusName;
    }

    return additionalDataCatalog;
};

export const getDefaultReviewsTotalParams = (code: string) => ({
    filter: {code: code as string},
});

export const getProductArtProperty = (properties?: IProperty[]) => {
    return properties?.find(({code}) => PRODUCT_PROPERTY_CODE_ART === code);
};

export const isArtProduct = (properties?: IProperty[]) => {
    const artProp = getProductArtProperty(properties);

    return Boolean(artProp?.value);
};
